<!-- *ngIf="!submitSuccess && !alreadyConfirm" -->

<div
  *ngIf="!isLoading && session"
  class="w-full lg:max-w-full lg:flex login-page"
>
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      --fond-ordinateur: url(&quot;assets/img/fond-activite-informelle.svg&quot;);
      --fond-mobile: url(&quot;assets/img/fond-activite-informelle-mobile.svg&quot;);
    "
  >
    <div class="w-4/5 grid-cols-1 flex place-content-center">
      <app-card-form class="carte-translucide">
        <div id="page-one">
          <!-- En-tête avec logos -->
          <div class="flex justify-between mb-10">
            <div
              class="logo-icon"
              style="
                background-image: url(&quot;assets/img/logo_unchk.png&quot;);
              "
            ></div>
            <div
              class="logo-icon"
              style="
                background-image: url(&quot;assets/img/logo_master_card.png&quot;);
              "
            ></div>
          </div>

          <!-- Titre -->

          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="font-bold text-2xl" *ngIf="activity">
                {{ activity.nomActivity | titlecase }}
              </span>
              <br />
              <!-- Sous-titre -->
              <span class="text-2xl">
                Gestion de la relation clientèle, compétences numériques
                essentielles, sécurité routière
              </span>
              <br />
              <!-- ===== DÉBUT MODIF : en-tête de l'activité ===== -->
              <div class="flex justify-center items-center">
                <div class="text-center">
                  <br />
                  <br />
                  <span class="font-bold text-2xl">L'activité se tiendra</span>
                  <br />
                  <br />
                  <p>
                    <strong>Date de début :</strong>
                    {{ activity.openDate | date: "EEEE d MMMM y"
                    }}<ng-container *ngIf="activity.hours"
                      >, à partir de
                      {{ heureCourte(activity.hours) }}</ng-container
                    >
                  </p>
                  <p *ngIf="!memeJour">
                    <strong>Date de fin :</strong>
                    {{ activity.closeDate | date: "EEEE d MMMM y" }}
                  </p>
                  <p *ngIf="villesActivite">
                    <strong>Lieu(x) :</strong> {{ villesActivite }}
                  </p>
                </div>
              </div>
              <!-- ===== FIN MODIF ===== -->
              <!-- Sous-titre -->
              <span class="text-2xl"> </span>
              <!-- Logo FORCE-N -->
              <div class="flex justify-center mt-6 mb-0">
                <div
                  class="logo-icon"
                  style="
                    background-image: url(&quot;assets/img/logo_force_n.png&quot;);
                  "
                ></div>
              </div>
            </div>
          </div>

          <!-- Texte d'introduction -->
          <div class="mt-0 mb-4 text-gray-800 text-sm leading-relaxed">
            <p class="mb-3">
              Chers commerçant(e)s, livreurs, coursiers, moto-taxis,
            </p>
            <p class="mb-3">
              Le programme Force N vous invite à participer
              <strong>gratuitement</strong> à la formation pratique sur la
              relation client et les outils numériques essentiels (WhatsApp
              Business, Google Maps, paiements mobiles) destinée aux
              commerçant(e)s.
            </p>
            <p class="mb-1 font-semibold">Pour votre confort :</p>
            <ul class="list-disc list-inside mb-3">
              <li>
                Une indemnité de transport de <strong>5 000 F CFA</strong> vous
                sera remise après la formation.
              </li>
              <li>
                Une <strong>Attestation de participation</strong> vous sera
                délivrée par la suite.
              </li>
              <li>
                Venez simplement avec votre <strong>téléphone portable</strong>.
              </li>
            </ul>
            <p class="font-semibold">Important :</p>
            <p>
              Places limitées et
              <strong>Candidatures féminines encouragées !</strong>
            </p>
          </div>

          <hr class="h-1 my-8 bg-green-500 border-0" />
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="formationForm" class="space-y-6">
            <div>
              <!-- SECTION I -->
              <div
                style="margin-top: 20px"
                class="flex justify-between gap-2 gap-6 my-6"
              >
                <span class="font-bold text-2xl">
                  I. INFORMATIONS PERSONNELLES
                </span>
              </div>

              <!-- Prénom - Nom -->
              <div class="grid md:grid-cols-3 md:gap-6 my-6">
                <!-- Label global desktop -->
                <div class="col-span-3 md:col-span-1 hidden md:block">
                  <div class="flex items-center gap-1">
                    <span>Prénom - Nom</span>
                    <span class="text-red-500">*</span>
                  </div>
                </div>

                <!-- Prénom -->
                <div class="col-span-3 md:col-span-1">
                  <label for="prenom" class="block mb-5 font-medium md:hidden">
                    Prénom <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-gray-300"
                    [formControl]="prenomCtrl"
                    [style.border]="
                      isFieldInvalid('prenom') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <p class="mt-3 hidden md:block">Prénom</p>
                </div>

                <!-- Nom -->
                <div class="col-span-3 md:col-span-1">
                  <label
                    for="nom"
                    class="block mb-5 mt-8 font-medium md:hidden"
                  >
                    Nom <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="nom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-gray-300 bg-white"
                    [formControl]="nomCtrl"
                    [style.border]="
                      isFieldInvalid('nom') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <p class="mt-3 hidden md:block">Nom</p>
                </div>
              </div>

              <!-- Sexe -->
              <div class="grid md:grid-cols-3 m-0 md:gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Sexe
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('sexe')" style="color: #eb1c1c">
                      Champ requis !
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center">
                    <input
                      formControlName="sexe"
                      id="sexeHomme"
                      type="radio"
                      value="homme"
                      name="sexe"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('sexe') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="sexeHomme"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Masculin</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center">
                    <input
                      formControlName="sexe"
                      id="sexeFemme"
                      value="femme"
                      type="radio"
                      name="sexe"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('sexe') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="sexeFemme"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Féminin</label
                    >
                  </div>
                </div>
              </div>

              <!-- Année de naissance -->
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Année de naissance &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div *ngIf="isFieldInvalid('age')" style="color: #eb1c1c">
                      Champ requis !
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="text"
                      formControlName="anneeNaissance"
                      maxlength="4"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 bg-white"
                      inputmode="numeric"
                      placeholder="Ex : 1998"
                      (input)="onlyYear($event)"
                    />
                  </div>
                </div>
              </div>

              <!-- Email -->
              <!-- <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">Adresse email</div>
                    <div *ngIf="isFieldInvalid('email')" style="color: #eb1c1c">
                      Champ requis !
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="email"
                      id="email"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      [formControl]="emailCtrl"
                      placeholder="Par ex : monnom@exemple.com"
                    />
                  </div>
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="email"
                      id="emailConfirm"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      [formControl]="emailConfirmCtrl"
                      placeholder="Veuillez saisir à nouveau votre adresse mail"
                    />
                    <div *ngIf="emailsMismatch" style="color: #eb1c1c">
                      Les adresses email ne correspondent pas !
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- Numéro Wave -->
              <div class="grid md:grid-cols-3 md:gap-6 my-6">
                <!-- Label global desktop -->
                <div class="col-span-3 md:col-span-1 hidden md:block">
                  <div class="flex items-center gap-1">
                    <span>Numéro Wave</span>
                    <span class="text-red-500">*</span>
                  </div>
                  <div
                    *ngIf="isFieldInvalid('waveNumber')"
                    class="text-red-600 mt-1"
                  >
                    Champ requis!
                  </div>
                </div>

                <!-- Numéro Wave input -->
                <div class="col-span-3 md:col-span-2">
                  <label
                    for="waveNumber"
                    class="block mb-5 mt-8 font-medium md:hidden"
                  >
                    Numéro Wave <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="waveNumber"
                    maxlength="9"
                    inputmode="numeric"
                    [formControl]="waveNumberCtrl"
                    (input)="onlyNumbers($event)"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 bg-white"
                    placeholder="Votre numéro Wave"
                  />
                  <p class="mt-3 hidden md:block">Numéro Wave</p>

                  <!-- Message numéro déjà existant — AJOUT -->
                  <div
                    *ngIf="telephoneDejaExistant"
                    class="text-red-600 mt-1 text-sm"
                  >
                    Ce numéro Wave a déjà bénéficié de la formation
                    Commerçant-Livreur.
                  </div>

                  <div
                    *ngIf="isFieldInvalid('waveNumber')"
                    class="text-red-600 mt-1 md:hidden"
                  >
                    Champ requis!
                  </div>
                </div>
              </div>

              <!-- Région de provenance -->
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Région de provenance &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('region')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="region"
                      id="region"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      [style.border]="
                        isFieldInvalid('region') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option value="" disabled selected>
                        -- Sélectionnez une région --
                      </option>
                      <option *ngFor="let city of cities" [value]="city.name">
                        {{ city.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Secteur d'activités -->
              <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Secteur d'activités
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('secteurActivite')"
                      style="color: #eb1c1c"
                    >
                      Champ requis !
                    </div>
                  </div>
                </div>
                <!-- Les options -->
                <div class="col-span-2">
                  <div class="flex flex-wrap gap-x-6 gap-y-2">
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="commerce"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        formControlName="secteurActivite"
                        value="Commerce (service ou produit)"
                        name="secteurActivite"
                      />
                      <label
                        for="commerce"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >Commerce (service ou produit)</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="moto-taxi"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        formControlName="secteurActivite"
                        value="Moto-Taxi"
                        name="secteurActivite"
                      />
                      <label
                        for="moto-taxi"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >Moto-Taxi</label
                      >
                    </div>

                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="restauration"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        formControlName="secteurActivite"
                        value="Restauration"
                        name="secteurActivite"
                      />
                      <label
                        for="restauration"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >Restauration</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="couture"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        formControlName="secteurActivite"
                        value="Couture"
                        name="secteurActivite"
                      />
                      <label
                        for="couture"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >Couture</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="artisanat"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        formControlName="secteurActivite"
                        value="Artisanat"
                        name="secteurActivite"
                      />
                      <label
                        for="artisanat"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >Artisanat</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="autreActivite"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        formControlName="secteurActivite"
                        value="Autre"
                        name="secteurActivite"
                      />
                      <label
                        for="autreActivite"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >Autre</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- Preciser Secteur d'activités-->
              <div *ngIf="showPreciser" class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Préciser Secteur d'activités
                    </div>
                    <div *ngIf="isFieldInvalid('age')" style="color: #eb1c1c">
                      Champ requis !
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="text"
                      id="preciserSecteur"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      formControlName="preciserSecteur"
                      [style.border]="
                        isFieldInvalid('preciserSecteur')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>

              <!-- SECTION II -->
              <hr class="h-1 my-8 bg-green-500 border-0" />
              <div class="flex justify-between gap-6 my-6">
                <span class="font-bold text-2xl">II. CHOIX DE SESSION</span>
              </div>

              <!-- Choix du lieu de formation -->
              <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Lieu de formation
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('ville')" style="color: #eb1c1c">
                      Champ requis !
                    </div>
                  </div>
                </div>

                <!-- Colonne 1 : lieux 0 → 2 -->
                <div class="relative z-0 w-full group grid grid">
                  <div
                    *ngFor="let lieu of lieuxColonne1"
                    class="flex items-start"
                  >
                    <input
                      type="radio"
                      [id]="'lieu-' + lieu.id"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="ville"
                      [value]="lieu.id"
                      name="ville"
                      (change)="onLieuChange(lieu.id)"
                      [style.border]="
                        isFieldInvalid('ville') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      [for]="'lieu-' + lieu.id"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {{ lieu.lieu }}
                    </label>
                  </div>
                </div>

                <!-- Colonne 2 : lieux 3 → 5 -->
                <div class="relative z-0 w-full group grid grid">
                  <div
                    *ngFor="let lieu of lieuxColonne2"
                    class="flex items-start"
                  >
                    <input
                      type="radio"
                      [id]="'lieu-' + lieu.id"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="ville"
                      [value]="lieu.id"
                      name="ville"
                      (change)="onLieuChange(lieu.id)"
                      [style.border]="
                        isFieldInvalid('ville') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      [for]="'lieu-' + lieu.id"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {{ lieu.lieu }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- Choix de la date — s'affiche uniquement si le lieu sélectionné a des dates futures -->
              <div
                *ngIf="datesDisponibles.length > 0"
                class="grid md:grid-cols-3 m-0 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Choisissez une date
                      <!-- <span
                        *ngIf="
                          villeCtrl.value !== null && villeCtrl.value !== ''
                        "
                      >
                        ({{ lieuFormation[villeCtrl.value]?.lieu }})
                      </span> -->
                      <span
                        *ngIf="
                          villeCtrl.value !== null && villeCtrl.value !== ''
                        "
                      >
                        ({{ lieuSelectionneLabel }})
                      </span>
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('date')" style="color: #eb1c1c">
                      Champ requis !
                    </div>
                  </div>
                </div>

                <div class="relative z-0 w-full group grid md:col-span-2">
                  <div
                    *ngFor="let date of datesDisponibles"
                    class="flex items-start"
                  >
                    <input
                      type="radio"
                      [id]="'date-' + date.id"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="date"
                      [value]="date.label"
                      name="date"
                      (change)="onDateChange(date.label)"
                      [style.border]="
                        isFieldInvalid('date') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      [for]="'date-' + date.id"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {{ date.label }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- Choix du créneau — visible uniquement après avoir choisi une date -->
              <div
                *ngIf="creneauxDisponibles.length > 0"
                class="grid md:grid-cols-3 m-0 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Choisissez un créneau
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('creneau')"
                      style="color: #eb1c1c"
                    >
                      Champ requis !
                    </div>
                  </div>
                </div>

                <div class="relative z-0 w-full group grid md:col-span-2">
                  <div
                    *ngFor="let creneau of creneauxDisponibles"
                    class="flex items-start"
                  >
                    <input
                      type="radio"
                      [id]="'creneau-' + creneau"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="creneau"
                      [value]="creneau"
                      name="creneau"
                      [style.border]="
                        isFieldInvalid('creneau') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      [for]="'creneau-' + creneau"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {{ creneau }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- Consentement -->
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Consentement &nbsp;
                      <p style="color: red">*</p>
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="my-6">
                    <div class="flex items-start gap-3">
                      <input
                        type="checkbox"
                        id="consentement"
                        formControlName="consentement"
                        class="w-5 h-5 mt-1 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        [style.border]="
                          isFieldInvalid('consentement')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <label
                        for="consentement"
                        class="text-sm text-gray-900 dark:text-gray-300"
                      >
                        J'autorise FORCE-N à conserver et à utiliser mes données
                        dans le cadre du programme. Les correspondances, les
                        certificats de réussite, l'accès aux plateformes de
                        formation et les badges seront générés à partir des
                        informations personnelles soumises ci-dessous. Veuillez
                        donc fournir des informations correctes et appropriées
                        <span style="color: red">*</span>
                      </label>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('consentement')"
                      style="color: #eb1c1c; margin-top: 4px"
                    >
                      Vous devez accepter pour continuer !
                    </div>
                  </div>
                </div>
              </div>

              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <!-- Messages d'erreur globaux -->
              <div
                class="flex justify-center items-center"
                *ngIf="filled"
                style="color: #eb1c1c"
              >
                Veuillez renseigner tous les champs requis!
              </div>
              <div
                class="flex justify-center items-center"
                *ngIf="erreur"
                style="color: #eb1c1c"
              >
                {{ infoResponse }}
              </div>
              <div>
                <app-spinner *ngIf="showSpinner"></app-spinner>
              </div>

              <!-- Bouton submit -->
              <div class="flex justify-center items-center">
                <button
                  type="submit"
                  class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 bg-orange-500 hover:bg-orange-600 btn-login"
                  [disabled]="isSubmitting"
                  (click)="onSubmitForm()"
                >
                  Confirmer
                </button>
              </div>

              <!-- Logo bas de page -->
              <div class="flex justify-center mt-8">
                <div
                  class="logo-icon"
                  style="
                    background-image: url(&quot;assets/img/logo_force_n.png&quot;);
                  "
                ></div>
              </div>
            </div>
          </form>
        </div>
      </app-card-form>
    </div>
  </div>
</div>
<!-- MODAL DÉJÀ CONFIRMÉ -->
<div
  *ngIf="alreadyConfirm"
  class="fond-informel h-screen w-screen"
  style="
    --fond-ordinateur: url(&quot;assets/img/fond-activite-informelle.svg&quot;);
    --fond-mobile: url(&quot;assets/img/fond-activite-informelle-mobile.svg&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div class="relative p-4 w-full max-w-md">
      <div class="bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-6 text-center">
          <svg
            class="mx-auto mb-4 text-blue-500 w-12 h-12"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 8.5h.01M11 11h1v4m9-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>

          <h2
            class="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3"
          >
            Inscription déjà confirmée
          </h2>

          <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
            Cher(e) <strong>{{ infoResponse }}</strong
            >, vous avez déjà confirmé votre inscription à la formation.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL SUCCÈS -->
<div
  *ngIf="submitSuccess"
  class="fond-informel h-screen w-screen"
  style="
    --fond-ordinateur: url(&quot;assets/img/fond-activite-informelle.svg&quot;);
    --fond-mobile: url(&quot;assets/img/fond-activite-informelle-mobile.svg&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div class="relative p-4 w-full max-w-md">
      <div class="bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-6 text-center">
          <svg
            class="mx-auto mb-4 text-green-500 w-12 h-12"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75l2.25 2.25L15 10.5m5.25 1.5a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z"
            />
          </svg>

          <h2
            class="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3"
          >
            Inscription confirmée
          </h2>

          <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
            Votre inscription à la formation a bien été enregistrée. Merci !
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Cas : inscriptions non encore ouvertes -->
<div
  *ngIf="!isLoading && noSession"
  class="fond-informel h-screen w-screen"
  style="
    --fond-ordinateur: url(&quot;assets/img/fond-activite-informelle.svg&quot;);
    --fond-mobile: url(&quot;assets/img/fond-activite-informelle-mobile.svg&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div class="relative p-4 w-full max-w-md">
      <div class="bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-6 text-center">
          <svg
            class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>

          <h2
            class="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3"
          >
            Inscriptions non encore ouvertes
          </h2>

          <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
            Aucune formation destinée aux
            <strong>commerçant(e)s, livreurs, coursiers, moto-taxis</strong>
            n'est actuellement disponible. Merci de votre intérêt et revenez
            prochainement pour consulter les prochaines sessions ouvertes à
            l'inscription.
          </p>

          <p class="text-sm text-gray-600 dark:text-gray-400 mt-3">
            Restez en contact avec nous sur
            <a
              class="text-blue-600 hover:underline"
              href="https://force-n.sn/"
              target="_blank"
              rel="noopener"
            >
              force-n.sn
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Cas : inscriptions clôturées -->
<div
  *ngIf="!isLoading && isClosed"
  class="fond-informel h-screen w-screen"
  style="
    --fond-ordinateur: url(&quot;assets/img/fond-activite-informelle.svg&quot;);
    --fond-mobile: url(&quot;assets/img/fond-activite-informelle-mobile.svg&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div class="relative p-4 w-full max-w-md">
      <div class="bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-6 text-center">
          <svg
            class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>

          <h2
            class="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3"
          >
            Inscriptions clôturées
          </h2>

          <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
            Les inscriptions pour cette formation destinée aux
            <strong>commerçant(e)s, livreurs, coursiers, moto-taxis</strong>
            sont désormais closes. Merci de votre intérêt et revenez
            prochainement pour consulter les prochaines sessions ouvertes à
            l'inscription.
          </p>

          <p class="text-sm text-gray-600 dark:text-gray-400 mt-3">
            Restez en contact avec nous sur
            <a
              class="text-blue-600 hover:underline"
              href="https://force-n.sn/"
              target="_blank"
              rel="noopener"
            >
              force-n.sn
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- MODAL ERREUR SERVEUR / RÉSEAU -->
<div
  *ngIf="errorMessage"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
>
  <div class="relative p-4 w-full max-w-md">
    <div class="bg-white rounded-lg shadow dark:bg-gray-700">
      <div class="p-6 text-center">
        <svg
          class="mx-auto mb-4 text-red-500 w-12 h-12"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>

        <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3">
          Inscription non enregistrée
        </h2>

        <p
          class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-6"
        >
          {{ errorMessage }}
        </p>

        <div class="flex justify-center gap-3">
          <button
            type="button"
            class="rounded-md px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200"
            (click)="closeError()"
          >
            Fermer
          </button>
          <button
            *ngIf="canRetry"
            type="button"
            class="rounded-md px-4 py-2 text-sm font-semibold text-white bg-orange-500 hover:bg-orange-600"
            (click)="retrySubmit()"
          >
            Réessayer
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
